import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryMediaHear } from './EventRegistryMediaHear';
import { EventRegistryMediaPlay } from './EventRegistryMediaPlay';
export class EventRegistryMedia extends EventRegistryCategory {
    label = 'Media';
    c_h = new EventRegistryMediaHear(this);
    c_p = new EventRegistryMediaPlay(this);
}
